export default __webpack_public_path__ + "static/planful-perform-logo-v2-white-479ee289826360b1fa96d4d85352b7f6.svg";